import { Link, usePush } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

// TODO: DREGAB-4137 Replace it on strong typed paths from common module
const MY_ACCOUNT_PATH = '/moje-konto/logowanie-nfz';

type NfzLoginLinkProps = {
   readonly testId: string;
};
export const NfzLoginLink = (props: NfzLoginLinkProps): JSX.Element => {
   const push = usePush();

   const handleClick = (): void => {
      push(MY_ACCOUNT_PATH);
   };

   return (
      <Link testId={props.testId} label={nfzSettingsTranslationKeys.nfzLogin} block={false} onClick={handleClick} />
   );
};
